import script from "./OrderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderView.vue?vue&type=script&lang=ts&setup=true"

import "./OrderView.vue?vue&type=style&index=0&id=650c1e28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650c1e28"]])

export default __exports__